// extracted by mini-css-extract-plugin
export default {"light_theme":"LayoutWrapperMain_light_theme__AKd37","root":"LayoutWrapperMain_root__JjFur"};